import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import './style.scoped.scss';
import UserInfo from './UserInfo';
import { HiDocumentText, HiOutlineChatAlt2, HiShare } from 'react-icons/hi';
import UserUpdates from './UserUpdates';
import { MdSummarize } from 'react-icons/md';

const mapStateToProps = (state) => ({
  documents: state.client.documents,
  user: state.user.user,
});

const Dashboard = ({ documents, user }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 690);

  // using refs to ensure the load logic works
  const screenRef = useRef(isSmallScreen);
  screenRef.current = isSmallScreen;

  useEffect(() => {
    // listen for changes in window width for hide/show logic
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const checkScreenSize = () => {
    screenRef.current = window.innerWidth > 690;
    setIsSmallScreen(screenRef.current);
  };

  return (
    <div className='dashboard'>
      <div className='dashboard__top'>
        <div
          className={`d-flex ${
            !isSmallScreen ? 'flex-column' : 'flex-row'
          } w-100`}
        >
          <div className={!isSmallScreen ? 'w-100' : 'col-6 m-0 p-0 mr-2'}>
            <UserInfo
              icon={<HiDocumentText />}
              title='Pages of Regulations Visited'
              percentage={
                (user.userUsage.pageviews /
                  user.userPlan.restrictions.pageviews) *
                100
              }
              progressBarText={`${user.userUsage.pageviews} out of ${user.userPlan.restrictions.pageviews}`}
              barColor='#123466'
              barId={
                user.userUsage.pageviews ===
                user.userPlan.restrictions.pageviews
                  ? 'visitedOpacity'
                  : 'visited'
              }
              showOverlay={
                user.userUsage.pageviews ===
                user.userPlan.restrictions.pageviews
              }
              overlayText='You have consumed all Page Views.'
            />
          </div>
          <div className={!isSmallScreen ? 'w-100 mt-4' : 'col-6 m-0 p-0 mr-2'}>
            <UserInfo
              isSmallScreen={isSmallScreen}
              iconId='pages-shared'
              icon={<HiShare />}
              title='Pages Shared'
              percentage={
                (user.userUsage.shares / user.userPlan.restrictions.shares) *
                100
              }
              progressBarText={`${user.userUsage.shares} out of ${user.userPlan.restrictions.shares}`}
              barColor='#ff7a00'
              barId={
                user.userUsage.shares === user.userPlan.restrictions.shares
                  ? 'sharedOpacity'
                  : 'shared'
              }
              showOverlay={
                user.userUsage.shares === user.userPlan.restrictions.shares
              }
              overlayText='You have consumed all Pages Shared.'
            />
          </div>
        </div>
        <div
          className={`d-flex ${
            !isSmallScreen ? 'flex-column' : 'flex-row'
          } w-100 mt-4`}
        >
          <div className={!isSmallScreen ? 'w-100' : 'col-6 m-0 p-0 mr-2'}>
            <UserInfo
              iconId='ai-queries'
              icon={<HiOutlineChatAlt2 />}
              title='AI Queries'
              percentage={
                (user.userUsage.queries / user.userPlan.restrictions.queries) *
                100
              }
              progressBarText={`${user.userUsage.queries} out of ${user.userPlan.restrictions.queries}`}
              barColor='#00a587'
              barId={
                user.userUsage.queries === user.userPlan.restrictions.queries
                  ? 'queriesOpacity'
                  : 'queryUsed'
              }
              showOverlay={
                user.userUsage.queries === user.userPlan.restrictions.queries
              }
              overlayText='You have consumed all AI Queries Credits.'
            />
          </div>
          <div className={!isSmallScreen ? 'w-100 mt-4' : 'col-6 m-0 p-0 mr-2'}>
            <UserInfo
              isSmallScreen={isSmallScreen}
              iconId='ai-summaries'
              icon={<MdSummarize />}
              title='AI Summaries'
              percentage={
                (user.userUsage.summaries /
                  user.userPlan.restrictions.summaries) *
                100
              }
              progressBarText={`${user.userUsage.summaries} out of ${user.userPlan.restrictions.summaries}`}
              barColor='#00a587'
              barId={
                user.userUsage.summaries ===
                user.userPlan.restrictions.summaries
                  ? 'summaryOpacity'
                  : 'summary'
              }
              showOverlay={
                user.userUsage.summaries ===
                user.userPlan.restrictions.summaries
              }
              overlayText='You have consumed all AI Summaries.'
            />
          </div>
        </div>
      </div>
      <div className='dashboard__bottom'>
        {/*  <UserUpdates
          // className={isSmallScreen ? 'mr-2' : ''}
          title='Recent Updates'
          array={documents ? documents : []}
        />*/}
        <UserUpdates
          className={isSmallScreen ? 'ml-2' : 'mt-4'}
          title='Recent Updates'
          array={documents ? documents : []}
        />
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(Dashboard);
